import { atom } from "recoil";

export const DataStatusState = atom({
  key: "DataStatusState",
  default: [],
});
